module.exports = __webpack_public_path__ + "img/電気回路_3_4_5.0b607c02.png";